import { ILopBanActionTypes } from "../../action-types/category/ILopBanActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ILopBanReducer } from "../../reducer-model/category/ILopBanReducer";

const initState: ILopBanReducer = {
  status: eReducerStatusBase.is_not_initialization,
  lopBans: [],
};
export const lopBanReducer = (
  state: ILopBanReducer = initState,
  action: ILopBanActionTypes
): ILopBanReducer => {
  switch (action.type) {
    case "LOP_BAN_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "LOP_BAN_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, lopBans: action.payload };
    case "LOP_BAN_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "LOP_BAN_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, lopBanEditing: action.payload };
    case "LOP_BAN_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };
    case "LOP_BAN_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "LOP_BAN_SAVE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false };
    case "LOP_BAN_SAVE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "LOP_BAN_DELETE_START":
      return { ...state, status: eReducerStatusBase.is_deleting };
    case "LOP_BAN_DELETE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "LOP_BAN_DELETE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
